import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceSetterComponent } from './price-setter/price-setter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '../form/form.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { CurrenciesModule } from '../../zalamo/currencies/currencies.module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { UserModule } from 'ZalamoLibrary/src/lib/zalamo/user/user.module';
import { ButtonModule } from '@ui/button/button/button.module';
import { SideDialogModule } from '@ui/side-dialog';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [PriceSetterComponent],
  exports: [PriceSetterComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
    MatFormFieldModule,
    MatIconModule,
    CurrenciesModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    UserModule,
    ButtonModule,
    SideDialogModule,
    MatBadgeModule,
  ],
})
export class PriceSetterModule {}
